// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--2cXSp"};